import Vue from "vue";
import VueRouter from "vue-router";
import beforeEach from "./beforeEach";
import Main from "../modules/main/Main.vue";
import Auth from "../modules/auth/Auth.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "Home" },
  },
  {
    path: "/",
    name: "Main",
    redirect: { name: "Home" },
    component: Main,
    children: [
      {
        path: "home",
        name: "Home",
        redirect: { name: "Overview" },
        component: () => import("@/modules/main/views/home/Home.vue"),
        children: [
          {
            path: "overview",
            name: "Overview",
            meta: {
              title: "Overview",
              requiresAuth: true,
            },
            component: () =>
              import(
                "@/modules/main/views/home/children/overview/Overview.vue"
              ),
          },
          {
            path: "account-details/:id",
            name: "AccountDetails",
            redirect: { name: "AccountSummary" },
            component: () =>
              import(
                "@/modules/main/views/home/children/accountDetails/AccountDetails.vue"
              ),
            children: [
              {
                path: "summary",
                name: "AccountSummary",
                meta: {
                  title: "Detalhes da conta",
                  requiresAuth: true,
                },
                component: () =>
                  import(
                    "@/modules/main/views/home/children/accountDetails/children/summary/Summary.vue"
                  ),
              },
              {
                path: "stats",
                name: "AccountStats",
                meta: {
                  title: "Estatísticas",
                  requiresAuth: true,
                },
                component: () =>
                  import(
                    "@/modules/main/views/home/children/accountDetails/children/stats/Stats.vue"
                  ),
              },
              {
                path: "edit",
                name: "EditAccount",
                meta: {
                  title: "Editar Conta API",
                  requiresAuth: true,
                },
                component: () =>
                  import(
                    "@/modules/main/views/home/children/accountDetails/children/editAccount/EditAccount.vue"
                  ),
              },
              {
                path: "trades",
                name: "Trades",
                meta: {
                  title: "Transações da conta",
                  requiresAuth: true,
                },
                component: () =>
                  import(
                    "@/modules/main/views/home/children/accountDetails/children/trades/Trades.vue"
                  ),
              },
              {
                path: "open-orders",
                name: "AccountOpenOrders",
                meta: {
                  title: "Ordens abertas",
                  requiresAuth: true,
                },
                component: () =>
                  import(
                    "@/modules/main/views/home/children/accountDetails/children/openOrders/OpenOrders.vue"
                  ),
              },
              {
                path: "open-positions",
                name: "AccountOpenPositions",
                meta: {
                  title: "Posições abertas",
                  requiresAuth: true,
                },
                component: () =>
                  import(
                    "@/modules/main/views/home/children/accountDetails/children/openPositions/OpenPositions.vue"
                  ),
              },
              {
                path: "position-history",
                name: "AccountPositionHistory",
                meta: {
                  title: "Histórico de posições",
                  requiresAuth: true,
                },
                component: () =>
                  import(
                    "@/modules/main/views/home/children/accountDetails/children/positionHistory/PositionHistory.vue"
                  ),
              },
              {
                path: "invoice",
                name: "AccountInvoice",
                meta: {
                  title: "Fatura",
                  requiresAuth: true,
                },
                component: () =>
                  import(
                    "@/modules/main/views/home/children/accountDetails/children/invoice/Invoice.vue"
                  ),
              },
            ],
          },
        ],
      },
      {
        path: "connect-exchange/:algorithmID?",
        name: "ConnectExchange",
        meta: {
          title: "Conectar Conta API",
          requiresAuth: true,
        },
        component: () =>
          import("@/modules/main/views/connectExchange/ConnectExchange.vue"),
      },
      {
        path: "algorithms",
        name: "Algorithms",
        component: () =>
          import("@/modules/main/views/algorithms/Algorithms.vue"),
        children: [
          {
            path: "",
            name: "Algorithms",
            meta: {
              title: "Algoritmos",
              requiresAuth: true,
              requiresPermission: "algorithms",
            },
            component: () =>
              import(
                "@/modules/main/views/algorithms/children/marketplace/Marketplace.vue"
              ),
          },
          {
            path: "details/:id",
            name: "AlgorithmDetails",
            meta: {
              title: "Detalhes do algoritmo",
              requiresAuth: true,
              requiresPermission: "algorithms",
            },
            component: () =>
              import(
                "@/modules/main/views/algorithms/children/algorithmDetails/AlgorithmDetails.vue"
              ),
          },
        ],
      },
      {
        path: "invoices",
        name: "Invoices",
        meta: {
          title: "Faturas",
          requiresAuth: true,
          //
        },
        component: () => import("@/modules/main/views/invoices/Invoices.vue"),
      },
      {
        path: "subscriptions",
        name: "Subscriptions",
        meta: {
          title: "Assinaturas",
          requiresAuth: true,
          //
        },
        component: () =>
          import("@/modules/main/views/subscriptions/Subscriptions.vue"),
      },
      {
        path: "commissions",
        name: "Commissions",
        meta: {
          title: "Comissões",
          requiresAuth: true,
          //
        },
        component: () =>
          import("@/modules/main/views/commissions/Commissions.vue"),
      },
    ],
  },
  {
    path: "/auth",
    name: "Auth",
    redirect: { name: "SignIn" },
    component: Auth,
    children: [
      {
        path: "sign-in",
        name: "SignIn",
        meta: { title: "Entrar", preventAuth: true },
        component: () => import("@/modules/auth/views/signIn/SignIn.vue"),
      },
      {
        path: "sign-up",
        name: "SignUp",
        meta: { title: "Criar Conta", preventAuth: true },
        component: () => import("@/modules/auth/views/signUp/SignUp.vue"),
      },
    ],
  },
  {
    path: "*",
    redirect: { name: "Home" },
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(beforeEach);

export default router;
